// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerTwo_wrapper__9C+q8","wrap":"BannerTwo_wrap__y43UC"};